import React, { useState } from "react";
import styled from "styled-components";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faFacebook,
  faPinterest,
  faInstagram,
  faYoutube,
  faQuora
} from "@fortawesome/free-brands-svg-icons";

const ModalBackground = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000;
`;

const ModalContent = styled.div`
  background-color: #f1f1f1;
  padding: 20px;
  border-radius: 8px;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
  text-align: center;
  width: 300px;
  position: relative;
`;

const CloseButton = styled.button`
  position: absolute;
  top: 10px;
  right: 10px;
  background: none;
  border: none;
  font-size: 20px;
  cursor: pointer;
  color: #888;
`;

const Title = styled.h2`
  font-size: 24px;
  margin: 10px 0;
  color: #333;
`;

const SocialIconsContainer = styled.div`
  display: flex;
  justify-content: center;
  gap: 15px;
  margin-top: 20px;
`;

const SocialIcon = styled.a`
  font-size: 30px;
  color: #e75b82;
  cursor: pointer;
  transition: color 0.2s;

  &:hover {
    color: #d44163;
  }
`;
const SocialMediaPopup = ({ handleCloseModal }) => {
    return (
      <ModalBackground>
        <ModalContent>
          <CloseButton onClick={handleCloseModal}>×</CloseButton>
          <Title>Follow Us</Title>
          <SocialIconsContainer>
            <SocialIcon
              href="https://www.facebook.com/MAJESTICGARBHSANSKAR"
              target="_blank"
              rel="noopener noreferrer"
            >
              <FontAwesomeIcon icon={faFacebook} />
            </SocialIcon>
            <SocialIcon
              href="https://www.instagram.com/garbhsanskarguru/"
              target="_blank"
              rel="noopener noreferrer"
            >
              <FontAwesomeIcon icon={faInstagram} />
            </SocialIcon>
            <SocialIcon
              href="https://www.youtube.com/channel/UCrQ2-hzImdJ4A3BD0yIYm-A"
              target="_blank"
              rel="noopener noreferrer"
            >
              <FontAwesomeIcon icon={faYoutube} />
            </SocialIcon>
            <SocialIcon
              href="https://garbhsanskarguru.quora.com/"
              target="_blank"
              rel="noopener noreferrer"
            >
              <FontAwesomeIcon icon={faQuora} />
            </SocialIcon>
            <SocialIcon
              href="https://in.pinterest.com/mgarbhsanskar/"
              target="_blank"
              rel="noopener noreferrer"
            >
              <FontAwesomeIcon icon={faPinterest} />
            </SocialIcon>
          </SocialIconsContainer>
        </ModalContent>
      </ModalBackground>
    );
  };
  
export default SocialMediaPopup;